import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.RIPPLING_DATA_EXTRACTOR_ROOT);
